<template>
  <div>
    <div class="form-section">
      <h3>Đăng ký tài khoản <br> TQC Tần Tử Anh</h3>
      <div class="login-inner-form">
        <form action="#" method="POST">
          <div class="form-group form-box">
            <input type="text" name="fullname" v-model="fullname" class="input-text" placeholder="Họ và Tên">
            <i class="flaticon-user"></i>
          </div>     
          <div class="form-group form-box">
            <input type="email" name="email" v-model="email" class="input-text" placeholder="Email">
            <i class="flaticon-mail-2"></i>
          </div>
          <div class="form-group form-box">
            <input type="text" name="phone" v-model="phone" class="input-text" placeholder="Số điện thoại">
            <i class="flaticon-facebook"></i>
          </div>
          
          <div class="form-group form-box">
            <input type="text" name="account" v-model="account" class="input-text" placeholder="Tài khoản Game">
            <i class="flaticon-user"></i>
          </div>
          <div class="form-group form-box">
            <input type="password" name="password" v-model="password" class="input-text" placeholder="Mật khẩu">
            <i class="flaticon-password"></i>
          </div>
          <div class="form-group form-box">
            <input type="password" name="re_password" v-model="re_password" class="input-text" placeholder="Nhập lại mật khẩu">
            <i class="flaticon-password"></i>
          </div>

          <div class="form-group mb-0">
            <button type="button" @click="register" class="btn-md btn-theme btn-block">Đăng Ký Ngay</button>
          </div>

          <p class="text">Bạn đã có tài khoản rồi?<router-link to="/dang-nhap"> Đăng nhập ở đây</router-link></p>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    name: 'Register',
    props: {
      tqc_api: String
    },
    data() {
      return {
        account: '',
        password: '',
        re_password: '',
        fullname: '',
        email: '',
        phone: '',
        clicked: false,
        user_ref: ''
      }
    },
    mounted() {
      localStorage.token = ''
      localStorage.user = ''
      localStorage.daily = ''

      this.user_ref = this.$route.params.account || ''
    },
    methods: {
      register() {
        if (this.clicked) {
          return false
        }
        if (!this.validate()) {
          alert('Vui lòng kiểm tra lại thông tin !')
          return false
        }
        this.clicked = true

        axios
          .post(`${this.tqc_api}register`, {
            account: this.account,
            password: this.password,
            re_password: this.re_password,
            phone: this.phone,
            email: this.email,
            fullname: this.fullname,
            user_ref: this.user_ref
          })
          .then(({
            data
          }) => {
            if (data.error != undefined) {
              alert(data.error)
            } else {
              // alert('Đăng ký tài khoản thành công !')
              alert(data.data)
              this.login()
              /* this.$router.push({
                name: 'Login'
              }) */
            }
            this.clicked = false
          })
          .catch(() => {
            this.clicked = false
          })

      },
      validate() {
        var isValid = 0
        if (this.fullname.length < 6) {
          isValid++
        }
        if (this.email.length < 6) {
          isValid++
        }
        /* if (this.phone.length < 6) {
          isValid++
        } */
        if (this.account.length < 6) {
          isValid++
        }
        if (this.password.length < 6) {
          isValid++
        }
        if (this.re_password.length < 6) {
          isValid++
        }
        if (this.re_password != this.password) {
          isValid++
        }
        return !isValid
      },
      login() {
        axios
          .post(`${this.tqc_api}login`, {
            account: this.account,
            password: this.password,
          })
          .then(({
            data
          }) => {
            localStorage.token = data.token
            this.$router.push({
              name: 'Account',
              params: {
                user: data
              }
            })
          })
          .catch(() => {})
      }
    }
  }
</script>

<style scoped>
  h3 {
    margin: 40px 0 0;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
</style>